import { createApp } from 'vue';
import Menu from './index.vue';

const app = createApp(Menu);
const instance = app.mount(document.createElement('div'));
document.body.appendChild(instance.$el);

const ld = {
  show(
    options = {
      showLoadingModal: true,
      isShowRightWrapper: true,
    },
  ) {
    instance.options = options;
    instance.show();
  },

  hide() {
    instance.hide();
  },
};

export default ld;
